var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.5 27.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.81,24H2.5A2.5,2.5,0,0,1,0,21.5V2.5A2.5,2.5,0,0,1,2.5,0h13A2.5,2.5,0,0,1,18,2.5V15.09A6.64,6.64,0,0,0,17,15V2.5A1.5,1.5,0,0,0,15.5,1H2.5A1.5,1.5,0,0,0,1,2.5v19A1.5,1.5,0,0,0,2.5,23h8.85A6,6,0,0,0,11.81,24Zm-.72-4H2.5a.5.5,0,0,1-.5-.5V3.5A.5.5,0,0,1,2.5,3h13a.5.5,0,0,1,.5.5V15.09a5.65,5.65,0,0,0-1,.26V4H3V19h8.35A5.65,5.65,0,0,0,11.09,20ZM9,1.5a.5.5,0,1,1-.5.5A.5.5,0,0,1,9,1.5Zm8,26A6.5,6.5,0,1,1,23.5,21,6.51,6.51,0,0,1,17,27.5Zm0-12A5.5,5.5,0,1,0,22.5,21,5.51,5.51,0,0,0,17,15.5Zm-.5,8.34a.51.51,0,0,1-.35-.15l-2.5-2.5a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l2.13,2.13,3.15-3.45a.5.5,0,1,1,.74.68l-3.5,3.83a.53.53,0,0,1-.36.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.4dcea97da59c168e4d86350eef4114ad.svg";
export { ForwardRef as ReactComponent };